import  { useState } from "react";
import { FaUser } from "react-icons/fa";
import { Box, Typography } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";

import "./styles.scss";
import deleteIcon from "../../../assets/img/Agent/deleteIcon.svg";
import DocIcon from "../../../assets/img/DocIcon.svg";
import FileUploadBox from "../../../assets/img/FileUploadBox.svg";
import downloadIcon from "../../../assets/img/Agent/downloadIcon.svg";
import { toast } from "react-toastify";
import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";

const MAX_FILE_SIZE_MB = 100;
const ALLOWED_FILE_TYPES = ["JPG", "PNG", "GIF", "PDF"];

const StepBox = ({ number, title }) => {
  return (
    <Box position="relative">
      <Box
        display="flex"
        alignItems="center"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        padding="6px"
        bgcolor="#ffffff"
        position="relative"
      >
        {/* Number Circle */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="40px"
          height="40px"
          border="2px solid #001d7e"
          borderRadius="50%"
          marginRight="8px"
        >
          <Typography variant="body1" color="#001d7e" fontWeight="bold">
            {number}
          </Typography>
        </Box>

        {/* Title */}
        <Typography variant="body1" fontWeight="bold" color="#001d7e">
          {title}
        </Typography>

        {/* Pointed edge - border */}
        <Box
          position="absolute"
          right="-21px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "21px solid #e0e0e0",
            borderTop: "21px solid transparent",
            borderBottom: "21px solid transparent",
          }}
        />

        {/* Pointed edge - fill */}
        <Box
          position="absolute"
          right="-20px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "20px solid #ffffff",
            borderTop: "20px solid transparent",
            borderBottom: "20px solid transparent",
            zIndex: 1,
            height: "60px",
          }}
        />
      </Box>
    </Box>
  );
};

const UploadUtilityBill = ({ onBack, refresh, setRefresh }) => {
  const [files, setFiles] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (uploadedFiles) => {
    // Convert FileList to Array for easier handling
    const filesArray = Array.from(uploadedFiles);

    // Validate file types
    const invalidFiles = filesArray.filter(
      (file) =>
        !ALLOWED_FILE_TYPES.includes(file.name.split(".").pop().toUpperCase())
    );

    if (invalidFiles.length > 0) {
      toast.error(
        `Invalid file type(s): ${invalidFiles.map((f) => f.name).join(", ")}`
      );
      return;
    }

    // Validate file sizes
    const oversizedFiles = filesArray.filter(
      (file) => file.size > MAX_FILE_SIZE_MB * 1024 * 1024
    );

    if (oversizedFiles.length > 0) {
      toast.error(
        `Files exceeding ${MAX_FILE_SIZE_MB}MB: ${oversizedFiles
          .map((f) => f.name)
          .join(", ")}`
      );
      return;
    }

    setFiles(filesArray);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!files?.length) {
      toast.error("Please select files to upload");
      return;
    }

    setIsUploading(true);

    try {
      // Create FormData for upload
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("file", file);
        formData.append("documentType", "UtilityBill");
      });

      const response = await axiosServicesOnboarding.post(
        "Customer/upload-document",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Upload response:", response);

      toast.success("Files uploaded successfully!");
      // setRefresh(!refresh);
      // onBack();
      window.location.reload();

      setFiles(null);
    } catch (error) {
      console.error("Upload error:", error?.response);
      toast.error(error.message || "Upload failed. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  const formatFileSize = (bytes) => {
    const kb = bytes / 1024;
    return kb < 1024 ? `${kb.toFixed(1)}KB` : `${(kb / 1024).toFixed(1)}MB`;
  };

  return (
    <div className="w-full md:w-[650px] mx-auto p-4">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2 text-gray-700 text-lg font-semibold">
          <FaUser className="text-xl text-primary-color" />
          <span>Upload Utility Bill</span>
        </div>
        <button onClick={onBack} className="text-gray-600 text-2xl">
          {/* <IoCloseOutline /> */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0003 29.3337C23.3641 29.3337 29.3337 23.3641 29.3337 16.0003C29.3337 8.63653 23.3641 2.66699 16.0003 2.66699C8.63653 2.66699 2.66699 8.63653 2.66699 16.0003C2.66699 23.3641 8.63653 29.3337 16.0003 29.3337Z"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 12L12 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12L20 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="px-8 py-2 bg-[#edf1f9] rounded-md mb-8">
        <Box maxWidth="600px" width="100%" p={2}>
          <StepBox number="01" title=" Upload Utility Bill" />
        </Box>
      </div>

      <h3 className="text-lg font-semibold text-primary-color text-center mb-6">
        Upload Utility Bill
      </h3>

      <form
        onSubmit={handleUpload}
        className="space-y-6 w-full md:w-[400px] mx-auto"
      >
        <Box className="bulk-upload2">
          <Box className="bulk-upload-body">
            <Typography
              sx={{ mt: 1 }}
              variant="subtitle2"
              align="center"
              className="upload_requirement"
            >
              Upload .PDF, .JPEG, or .PNG file{" "}
              <span className="text-red-500">*</span>
            </Typography>

            <div className="file-upload-wrapper">
              <div className="uploaded_file">
                {files?.map((file, index) => (
                  <div key={index} className="uploaded_file_container">
                    <div className="uploaded_file_details">
                      <img src={DocIcon} alt="Document" />
                      <div className="upload_details">
                        <span>{file.name}</span>
                        <span>{formatFileSize(file.size)}</span>
                      </div>
                    </div>

                    <div className="upload_icons">
                      <img src={downloadIcon} alt="Download file" />
                      <img
                        src={deleteIcon}
                        alt="Delete file"
                        onClick={() => setFiles(null)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <FileUploader
                children={
                  <div className="upload_dialog">
                    <div className="upload_img">
                      <img src={FileUploadBox} alt="Upload box" />
                    </div>
                    <Typography
                      variant="h6"
                      component="h2"
                      align="center"
                      className="upload_title"
                    >
                      <span className="upload_title_dark">
                        {files ? "Replace file" : "Select file"}
                      </span>
                      <span className="upload_title_light">
                        or drag and drop it here
                      </span>
                    </Typography>
                  </div>
                }
                maxSize={MAX_FILE_SIZE_MB}
                onSelect={handleFileChange}
                multiple={true}
                handleChange={handleFileChange}
                name="file"
                types={ALLOWED_FILE_TYPES}
                hoverTitle="Drop here"
              />
            </div>
          </Box>
        </Box>

        <button
          type="submit"
          disabled={isUploading || !files}
          className={`w-full text-white hover:hover:bg-[#8388B6] font-semibold py-4 px-6 rounded-md bg-primary-color ${
            isUploading || !files ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {isUploading ? "Uploading..." : "Upload"}
        </button>
      </form>
    </div>
  );
};

export default UploadUtilityBill;
